
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/player/[type]/[id]",
      function () {
        return require("private-next-pages/player/[type]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/player/[type]/[id]"])
      });
    }
  